import * as actions from "actions/user";

export default (state = {}, { type, payload }) => {
  switch (type) {
    case actions.FETCH_ONE_SUCCESS:
      return payload.data;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/location/item.js